














import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import ShoppingCartContinueShopping from '@accounting/components/shopping-cart/shopping-cart-continue-shopping.vue';
import InvoiceShoppingCartWizard from '@accounting/components/shopping-cart/wizard/invoice-shopping-cart-wizard.vue';

@Component({
  name: 'bpc-invoice-shopping-cart-page',
  components: {
    'bpc-page-title': BpcPageTitle,
    'bpc-invoice-shopping-cart-wizard': InvoiceShoppingCartWizard,
    'bpc-shopping-cart-continue-shopping': ShoppingCartContinueShopping,
  },
})
export default class ShoppingCartPage extends Vue {
  @Prop(String) readonly token: string;
  step: string = 'invoice-preview';
}
